"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tappedPromoSpace = void 0;

var _Schema = require("../../Schema");

/**
 * A user taps a promo space on the home page of the app
 *
 * subject is the text of the tapped promo space
 *
 * @example
 * ```
 * tappedPromoSpace({
 *   path: "/collection/a-collection-id",
 *   subject: "Check out this sweet collection!"
 * })
 * ```
 */
var tappedPromoSpace = function tappedPromoSpace(_ref) {
  var path = _ref.path,
      subject = _ref.subject;
  return {
    action: _Schema.ActionType.tappedPromoSpace,
    context_module: _Schema.ContextModule.promoSpace,
    context_screen_owner_type: _Schema.OwnerType.home,
    destination_path: path,
    subject: subject
  };
};

exports.tappedPromoSpace = tappedPromoSpace;